import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import {
  textAreaMaxLength,
  linkValidation, renderField, required, requiredSelect
} from '../../common/helpers/form-validations';
import { notifySet } from '../../Services/Actions/CommonActions';
import { renderDatePicker, renderServiceProviderSelect } from '../../Services/config/globals';
import { getImage } from '../../Services/Utils/FileApis';
import { serviceProviderList } from '../../Services/Utils/ServiceProviderApis';

function NotificationForm(props) {
  const {
    handleSubmit, onButtonClick, notificationText,
    invalid, pristine, submitSucceeded
  } = props;
  const dispatch = useDispatch();
  const [listItems, setListItems] = useState();

  const getServiceProviderDropDownList = () => {
    const data = {
      status: {
        id: 2,
      },
      enableNotification: true
    };
    const params = {
      start: 0,
      recordSize: '',
    };
    serviceProviderList(data, params).then(async (res) => {
      const { list, hasError } = res;
      const categoryList = [];
      if (hasError === false) {
        list.forEach((row) => {
          categoryList.push({
            id: row.id,
            label: row.name,
            value: row.name,
            path: `${getImage(row.logoView)}`,
          });
          setListItems(categoryList);
        });
      } else {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  useEffect(() => {
    getServiceProviderDropDownList();
  }, []);

  const onSubmit = (formData) => {
    onButtonClick(formData);
  };
  return (
    <div>
      <form
        form="notificationForm"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <h6>{notificationText}</h6>
            <div className="form-group col-lg-6">
              <label htmlFor="servicecategory">
                Service Partner <span className="validation-icon">*</span>
              </label>
              <Field
                type="dropdown"
                name="serviceProvider"
                placeholder="-- select one --"
                id="servicecategory"
                className="form-control"
                component={renderServiceProviderSelect}
                validate={[requiredSelect]}
                options={listItems}
              />
            </div>
            <div className="form-group">
              <label htmlFor="notificationDescription">
                Notification Description In One Liner <span className="validation-icon">*</span>
              </label>
              <Field
                type="textarea"
                maxLength={150}
                id="notificationDescription"
                className="form-control"
                placeholder="Notification Description"
                component={renderField}
                name="notificationDescription"
                validate={[required, textAreaMaxLength]}
              />
            </div>
            <div className="form-group">
              <label htmlFor="notificationLink">
                Notification Link <span className="validation-icon">*</span>
              </label>
              <Field
                id="notificationLink"
                className="form-control"
                placeholder="https://www.abc.com"
                component={renderField}
                name="notificationLink"
                validate={[required, linkValidation]}
              />
            </div>
            <div className="form-group col-lg-6">
              <label htmlFor="notificationEndDate">
                Notification Deadline <span className="validation-icon">*</span>
              </label>
              <Field
                type="date"
                name="notificationEndDate"
                id="notificationEndDate"
                className="form-control"
                component={renderDatePicker}
                validate={[required]}
              />
            </div>
            <div className="form-group">
              <div className="form-group">
                <label htmlFor="location">
                  Location
                </label>
                <Field
                  id="location"
                  className="form-control"
                  placeholder="Enter here"
                  component={renderField}
                  name="location"
                />
              </div>
            </div>
            <div className="form-group">
              <Button
                className="btn btn-red"
                type="submit"
                disabled={submitSucceeded || invalid || pristine}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'notificationForm',
});

export default withForm(NotificationForm);
